
import {
    Component,
    EventEmitter,
    Input,
    OnInit,
    Output
} from '@angular/core';

import { SearchService } from '../search/search.service';
import { SearchQueryDef } from '../search/search-query-def';
import { TranslationService } from '@services/translation.service';
import { PartialCvExternalJobName } from './pharma/models/partial-cv-external-job-name';

@Component({
    selector: 'external-job-name-select',
    template: `
    <div class="external-job-name-select">
        <climb-typeahead
            [(model)]="model"
            [resultFormatter]="externalJobNameFormatter"
            [keyFormatter]="externalJobNameKeyFormatter"
            [search]="searchExternalJobNames"
            [keySearch]="searchExternalJobNamesByKey"  
            [required]="required"
            [disabled]="disabled"
            [placeholder]="placeholder"
            [namespace]="'externalJobName'"
            (selectItem)="selectItemHandler($event)"
            #typeahead
        ></climb-typeahead>
    </div>
    `,
   styles: [`
    .external-job-name-select {
        min-width: 300px;
    }
`]
})
export class ExternalJobNameSelectComponent implements OnInit {
    @Input() model: number | null;
    @Input() required: boolean;
    @Input() disabled: boolean;

    @Output() modelChange: EventEmitter<PartialCvExternalJobName> = new EventEmitter<PartialCvExternalJobName>();

    placeholder: string;

    constructor (
        private searchService: SearchService,
        private translationService: TranslationService
    ){

    }

    ngOnInit() {
        this.placeholder = 'External ' + this.translationService.translate('Job') + ' Name'
    }

    selectItemHandler(item: PartialCvExternalJobName) {
        this.modelChange.emit(item);
    }

    searchExternalJobNames = (search: string): Promise<PartialCvExternalJobName[]> => {

        const filter = {
            ExternalJobName: search
        };

        return this._searchExternalJobNames(filter, 50);
    }

    searchExternalJobNamesByKey = (key: string): Promise<PartialCvExternalJobName[]> => {
        const filter = {
            ExternalJobNameKey: Number(key)
        };
        return this._searchExternalJobNames(filter, 1);
    }

    _searchExternalJobNames(thisFilter: Record<string, number | string>, count: number): Promise<PartialCvExternalJobName[]> {
        const searchQueryDef: SearchQueryDef = {
            entity: 'cv_ExternalJobNames',
            page: null,
            size: count,
            sortColumn: 'DateCreated',
            sortDirection: 'desc',
            isActive: true,
            filter: thisFilter
        };
        return this.searchService.getEntitiesBySearch(searchQueryDef).then((results: any) => {
            return results.data;
        });
    }

    externalJobNameFormatter = (item: PartialCvExternalJobName) => {
        return item.ExternalJobName;
    }

    externalJobNameKeyFormatter = (item: PartialCvExternalJobName) => {
        return item.ExternalJobNameKey;
    }
}